// import components
import { styled, Box } from '@mui/material';

export const StyledWarningContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.vars.palette.Alert.warningStandardBg,
  color: theme.palette.warning.main,
  borderRadius: theme.spacing(2),
  padding: theme.spacing(1.5, 2),
  gap: theme.spacing(2),
  margin: theme.spacing(1, 0, 5, 0)
}));
